import type { ReactNode } from 'react';
import { ErrorState } from '@/components/kit/Note';
import { Pagination } from '@/components/kit/Pagination';
import { Panel } from '@/components/kit/Panel';
import { Avatar } from '@/components/kit/Person';

/**
 * Таблица списка в панели с тремя обязательными состояниями (ТЗ M2 §8):
 * загрузка — скелет строк той же формы, ошибка — `.alert.crit` с «Повторить»,
 * пусто — `.empty` с выходом (сбросить фильтры или создать запись).
 */
export function ListPanel({
  head,
  rows,
  cols,
  loading,
  error,
  onRetry,
  errorTitle,
  empty,
  paging,
}: {
  head: ReactNode;
  rows: ReactNode;
  cols: number;
  loading: boolean;
  error: Error | null;
  onRetry: () => void;
  errorTitle: string;
  /** Что показать, если строк нет; null — строки есть */
  empty: ReactNode | null;
  paging?: { page: number; pageSize: number; total: number; shown: number; onPage: (p: number) => void };
}) {
  let body: ReactNode;
  if (error) {
    body = <ErrorState title={errorTitle} message={error.message} onRetry={onRetry} />;
  } else if (loading) {
    body = (
      <table className="tbl">
        <thead>{head}</thead>
        <tbody>
          {[62, 48, 70, 55, 66].map((w) => (
            <tr key={w}>
              <td data-col="primary">
                <div className="cwho">
                  <Avatar initials="" size={32} />
                  <div className="skel" style={{ width: `${w}%` }} />
                </div>
              </td>
              {Array.from({ length: cols - 1 }, (_, i) => (
                <td key={i} data-col="hide">
                  <div className="skel" style={{ width: `${70 - i * 8}%` }} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  } else if (empty) {
    body = <div className="empty">{empty}</div>;
  } else {
    body = (
      <>
        <table className="tbl">
          <thead>{head}</thead>
          <tbody>{rows}</tbody>
        </table>
        {paging ? <Pagination {...paging} /> : null}
      </>
    );
  }
  return <Panel flush>{body}</Panel>;
}
